<template>
  <div class="w100p pl10 pr10" >
   <div class="textc mb20">
     <p class="textc fs9  fwbold">{{ $t('miniprogram', 'categoryModule') }}</p>
   </div>

   <p class="fs8 mt10 mb10 fwbold">
      {{ $t('miniprogram', 'displayStyle') }}
    </p>
    <div class="d-flex flex-wrap-y">
      <div class="ml10" v-for="(item,index) in listData.list" :key="index" @click="currentTab = item">
        <img :src="item.img" v-if="item.img" class="w70 h70 ml10 mr10">
      </div>
    </div>
    <div class="">
      <p class="fs8 mt10 mb10 fwbold">
        {{ $t('miniprogram', 'styleSettings') }}
      </p>
     <div class="ml20">
        <el-upload
                  accept="image/jpeg,image/png"
                  class="addTabIconTap"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :on-success="bannerSuccess"
                  :before-upload="beforeUploadImageDynamicPic">
              <img v-if="currentTab.img" :src="currentTab.img" class="w100p h100p">
              <i v-else class="el-icon-plus"></i>
              
        </el-upload>
        <p class="fs6 mb10" v-if="size">{{ $t('miniprogram', 'iconUploadNote') }}</p>
        <p class="fs6 mb10" v-else>{{ $t('miniprogram', 'iconUploadNote') }}</p>
     </div>
      <!-- <p class="fs8  mb10 " @click="">恢复默认样式</p> -->
      <p class="fs8 mt10 mb10 fwbold">
        {{ $t('miniprogram', 'titleSettings') }}
      </p>
      <el-input :placeholder="currentTab.title" v-model="currentTab.title" maxlength="4" show-word-limit class="mb10 w200 ml20"></el-input>
      <p class="fs8 mt10 mb10 fwbold">
        {{ $t('miniprogram', 'jumpSettings') }}
      </p>
      <el-select
        v-model="currentTab.name"
        class="ml20 mb20"
        style="width: 150px;"
        :placeholder="$t('miniprogram', 'pleaseSelect')"
        @change="select_tap($event)"
      >
        <el-option
          v-for="(v) in optionList"
          :key="v.name"
          :label="v.name"
          :disabled="v.disabled"
          :value="v.name"
        />
      </el-select>
      
    </div>
    <div class="ml20">
      <el-button type="primary" class="" @click="reset_tab_tap">
        {{ $t('miniprogram', 'iconReset') }}
      </el-button>
    </div>
  
   
  </div>
</template>

<script>

import {
  selectGoodsTypeInfoPC,
} from "@/api/coupon.js";
import { getDataTimeSec } from "@/utils";
import commonTable from "@/components/common/commonTable";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  props:['listData','size'],
  data() {
    return {
      currentTab:'',
      optionList:[{
        name: this.$t('miniprogram', 'no')
      }],
      uploadUrl:this.$store.state.uploadingUrl,
      ossUrl:this.$store.state.ossUrl,
      oldTab:{
        list:[{
          img:'https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/yimai_photos/ecommerce/tab1.png',

          title:'衣服'
        },{
          img:'https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/yimai_photos/ecommerce/tab2.png',
          title:'裤子'
        },{
          img:'https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/yimai_photos/ecommerce/tab3.png',
          title:'帽子'
        },{
          img:'https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/yimai_photos/ecommerce/tab4.png',
          title:'鞋子'
        }],
      
        type:'tab'
      }
    };
  },
  watch:{
    listData:{
      handler(val){
        console.log(val)
        this.currentTab = val.list[0]
      },
      immediate:true
    }
  },
  created(){
   this.queryClassify()
  },
  methods:{
    
    queryClassify(){
      let data = {
        pageSize: 999
      }
      selectGoodsTypeInfoPC(data)
      .then(res=>{
        if(res.data){
          this.optionList = res.data.pageInfo.list
          this.optionList.unshift({
            name: this.$t('miniprogram', 'no')
          })
        }else{
          this.optionList = []
        }
      })
      .catch(err=>{
        
      })
    },
    restTab(){

    },
    select_tap(e){
      let than = this
      than.optionList.forEach(item=>{
        console.log(item)
        if(item.name == than.currentTab.name){
          than.currentTab.goodstypeId = item.goodstypeId
          item.disabled = true
        }
      })
      console.log(this.currentTab)
    },
    bannerSuccess(res){
      //动态图上传成功
      // if(!obj.type){
      //   var index = obj.index;
      //   this.$set(this.mallBanner[index],'img',this.ossUrl + '/' + res.data)
      // }else{
      //   var index = obj.index;
      //   this.$set(this.appointmentBanner[index],'img',this.ossUrl + '/' + res.data)
      // }
      this.currentTab.img = this.ossUrl + '/' + res.data
      
    },
    beforeUploadImageDynamicPic(file){
      var _this = this;
      var isLt10M = file.size / 1024 / 1024  < 10;
      if (['image/jpeg', 'image/png'].indexOf(file.type) == -1) {
          _this.$message.error(this.$t('miniprogram', 'uploadCorrectImageFormat'));
          return false;
      }
      if (!isLt10M) {
          _this.$message.error(this.$t('miniprogram', 'uploadImageSizeLimit'));
          return false;
      }
    },
    reset_tab_tap(){
      this.optionList.forEach(item=>{
        item.disabled = false
      })
      this.$emit('reset_tab_tap',this.oldTab)
    }
  }
};
</script>

<style lang="scss" scoped>
 /deep/.addTabIconTap .el-upload--text{
  width: 70px;
  height: 70px;
  line-height: 70px;
}
/deep/ .addTabIconTap .el-upload-list__item {
  width: 70px;
  height: 70px;
  line-height: 70px;
}
</style>